/**
 * MoneyLinkサーバーエラータイプ管理
 */
export const ErrorType = {
  /** メンテナンスエラー */
  MAINTENANCE_ERROR: "webmoneylink_maintenance",
  /**セッション期限切れエラー */
  SESSION_INVALID: "webmoneylink_session_invalid",

  /**口座同期不可エラー */
  REAUTH_FOR_SYNC: "linkstorage_reauth_for_synchronize",

  /**アクセストークン不正エラー(accounts) */
  //ACCOUNTS_INVALID_ACCESS_TOKEN: "accounts_invalid_accesstoken",
  // クライアント起因のパラメーターエラー
  ACCOUNTS_CLIENT_PARAMETER_ERROR: "accounts_client_parameter_error",
  /**アクセストークン失効エラー(accounts) */
  //ACCOUNTS_EXPIRED_ACCESS_TOKEN: "accounts_access_token_expired",
  /**アクセストークン不正エラー(linkstorage) */
  //LINKSTORAGE_INVALID_ACCESS_TOKEN: "linkstorage_invalid_accesstoken",
  /**アクセストークン不正エラー(analyzer) */
  //ANALYZER_INVALID_ACCESS_TOKEN: "analyzer_invalid_accesstoken",
  /**アクセストークン不正エラー(sp: 原則不要だが互換性のため念の為定義) */
  //SP_INVALID_ACCESS_TOKEN: "sp_invalid_accesstoken",

//  /**発行請求書番号重複エラー */
//  INVOICE_ISSUANCE_PUT_NUMBER_DUPLICATED: "evidencer_duplicate_invoice_number_error",
//  /**発行見積書番号重複エラー */
//  QUOTATION_ISSUANCE_PUT_NUMBER_DUPLICATED: "evidencer_duplicate_quotation_number_error",
//  /**発行領収書番号重複エラー */
//  RECEIPT_ISSUANCE_NUMBER_DUPLICATE: "evidencer_duplicate_receipt_number_error",
//  /**発行納品書番号重複エラー */
//  DELIVERY_ISSUANCE_NUMBER_DUPLICATE: "evidencer_duplicate_delivery_number_error",
//  /**発行支払通知書番号重複エラー */
//  PAYMENT_NOTIFICATION_ISSUANCE_NUMBER_DUPLICATE:
//    "evidencer_duplicate_payment_notification_number_error",
//  /**文書明細件数超過エラー */
//  DOCUMENT_DETAILS_OVERFLOW: "evidencer_document_details_overflow_warn",
//  /**請求書非存在エラー */
//  INVOICE_NOT_EXIST: "evidencer_invoice_not_exist_warn",
//  /**領収書非存在エラー */
//  RECEIPT_NOT_EXIST: "evidencer_receipt_not_exist_warn",
//  /**納品書非存在エラー */
//  DELIVERY_NOT_EXIST: "evidencer_delivery_not_exist_warn",
//  /**見積書非存在エラー */
//  QUOTATION_NOT_EXIST: "evidencer_quotation_not_exist_warn",
//  /**支払通知書非存在エラー */
//  PAYMENT_NOTIFICATION: "evidencer_payment_notification_not_exist_warn",
//  /**閲覧文書非存在エラー */
//  DOCUMENT_VIEW_NOT_EXIST: "evidencer_document_view_not_exist_warn",
//  /**取引先情報非存在エラー */
//  PARTNER_NOT_EXIST: "evidencer_partner_not_exist_warn",
//  /**品目情報非存在エラー */
//  ITEM_NOT_EXIST: "evidencer_item_not_exist_warn",
//  /**振込先口座情報未登録エラー */
//  PAYABLE_FINANCE_ACCOUNT_UNREGISTERED: "evidencer_payable_finance_account_unregistered_warn",
//  /**取引先情報未登録エラー*/
//  PARTNER_ID_UNREGISTERED: "evidencer_partner_id_unregistered_error",
//  /**請求書未発見エラー */
//  INVOICE_NOT_FOUND: "evidencer_invoice_not_found_warn",
//  /**領収書未発見エラー */
//  RECEIPT_NOT_FOUND: "evidencer_receipt_not_found_warn",
//  /**納品書未発見エラー */
//  DELIVERY_NOT_FOUND: "evidencer_delivery_not_found_warn",
//  /**見積書未発見エラー */
//  QUOTATION_NOT_FOUND: "evidencer_quotation_not_found_warn",
//  /**支払通知書未発見エラー */
//  PAYMENT_NOTIFICATION_NOT_FOUND: "evidencer_payment_notification_not_found_warn",
//  /**取引先未発見エラー */
//  PARTNER_NOT_FOUND: "evidencer_partner_not_found_warn",
//  /**文書取引先ID非存在エラー */
//  DOCUMENT_POST_PUT_PARTNER_ID_NOT_EXIST: "evidencer_document_post_put_partner_id_not_exist",
//  /**確定済み受取文書更新エラー */
//  CONFIRMED_RECEIVING_DOCUMENT_UPDATE: "confirmed_receiving_document_update_error",
//
//  /**編集対象の文書がすでに発行済みエラー */
//  INVOICE_ISSUANCE_ALREADY_CLAIMED: "evidencer_invoice_issuance_already_claimed_warn",
//  QUOTATION_ISSUANCE_ALREADY_CLAIMED: "evidencer_quotation_issuance_already_claimed_warn",
//  DELIVERY_ISSUANCE_ALREADY_CLAIMED: "evidencer_delivery_issuance_already_claimed_warn",
//  RECEIPT_ISSUANCE_ALREADY_CLAIMED: "evidencer_receipt_issuance_already_claimed_warn",
//  PAYMENT_NOTIFICATION_ISSUANCE_ALREADY_CLAIMED:
//    "evidencer_payment_notification_issuance_already_claimed_warn",
//
  /**画像重複登録エラー */
  SK_DUPLICATED_IMAGE_ERROR: "sk_server_duplicateimage_error",

//  /**クーポン登録エラー */
//  SK_USE_COUPON_ERROR: "sk_use_coupon_error",
//  DUPLICATED_NOT_USE_COUPON_ERROR: "duplicated_not_use_coupon_error",
//  ALREADY_PAID_NOT_USE_COUPON_ERROR: "already_paid_not_use_coupon_error",
//  EXPIRED_USE_COUPON_ERROR: "expired_use_coupon_error",
//
//  /**セッションにsori_idが存在しないエラー */
//  IV_SERVER_SORI_ID_NOT_EXIST: "iv_server_sori_id_not_exist",
//
//  /**SMS認証チェックエラー */
//  ACCOUNTS_SMS_AUTHCODES_INVALID: "accounts_sms_authcodes_invalid",
//
//  /**企業情報検索エラー */
//  EVIDENCER_NTA_COMPANY_DATA_SEARCH_WARN01: "evidencer_nta_company_data_search_warn01",
//  EVIDENCER_NTA_COMPANY_DATA_SEARCH_WARN02: "evidencer_nta_company_data_search_warn02",
//  EVIDENCER_NTA_COMPANY_DATA_RESULTS_WARN: "evidencer_nta_company_data_results_warn",
//
//  /**取引先登録編集バリデーションエラー */
//  EVIDENCER_PARTNER_VALIDATE_LEGAL_ENTITY_ID_WARN:
//    "evidencer_partner_validate_legal_entity_id_warn",
//  EVIDENCER_PARTNER_VALIDATE_POSTAL_ZONE_WARN: "evidencer_partner_validate_postal_zone_warn",
//
//  /**会社情報入力エラー */
//  COMPANIES_VALIDATE_POST_CODE_ERROR: "evidencer_companies_validate_post_code_warn",
//  COMPANIES_VALIDATE_LEGAL_ENTITY_COMPANY_ID_ERROR:
//    "evidencer_companies_validate_legal_entity_company_id_warn",
//  COMPANIES_VALIDATE_INSTITUTION_NAME_ERROR: "evidencer_companies_validate_institution_name_warn",
//  COMPANIES_VALIDATE_BRANCH_NAME_ERROR: "evidencer_companies_validate_branch_name_warn",
//
//  /**権限不足エラー */
//  INVITATION_USER_IN_FREE_PLAN_ERROR: "invitation_user_in_free_plan_error", // 無料プランかつ権限がメンバー
//
//  /**課金状態が合致しないエラー */
//  BILLING_STATUS_UNMATCH_ERROR: "billing_status_unmatch_error",
//
//  /**請求書作成枚数上限エラー */
//  EVIDENCER_INVOICE_ISSUANCE_COUNT_VALIDATION_ERROR:
//    "evidencer_invoice_issuance_count_validation_error",
//  EVIDENCER_INVOICE_RECEIVING_COUNT_VALIDATION_ERROR:
//    "evidencer_invoice_receiving_count_validation_error",
//  EVIDENCER_OCR_EVIDENCE_COUNT_VALIDATION_ERROR: "evidencer_ocr_evidence_count_validation_error",
//  EVIDENCER_DATA_IMPORT_ISSUANCE_INVOICE_OVER_FREE_LIMIT:
//    "evidencer_data_import_issuance_invoice_over_free_limit",
//  EVIDENCER_DATA_IMPORT_ISSUANCE_INVOICE_ALREADY_OVER_FREE_LIMIT:
//    "evidencer_data_import_issuance_invoice_already_over_free_limit",
//
//  /**支払通知書作成枚数上限エラー */
//  EVIDENCER_PAYMENT_NOTIFICATION_ISSUANCE_COUNT_VALIDATION_OVER_ERROR:
//    "evidencer_payment_notificatio_issuance_count_validation_error",
//
//  /**退会時課金状態チェックエラー */
//  ValidSubscriptionZuoraAlreadyExist: "valid_subscription_zuora_already_exist",
//  ValidNotAutoRenewSubscriptionZuoraAlreadyExist:
//    "valid_not_auto_renew_subscription_zuora_already_exist",
//  ValidSubscriptionAppleSKAlreadyExist: "valid_subscription_apple_sk_already_exist",
//  ValidSubscriptionGoogleSKAlreadyExist: "valid_subscription_google_sk_already_exist",
//  ValidSubscriptionAppleIVAlreadyExist: "valid_subscription_apple_iv_already_exist",
//  ValidSubscriptionGoogleIVAlreadyExist: "valid_subscription_google_iv_already_exist",
//
//  /**クレジットカード加盟店チェックエラー(billings) */
//  ValidMemberStoreInvalidCardNumber: "valid_member_store_invalid_card_number",
//
//  /*アプリ外課金解約済みエラー */
//  ZuoraAllPlanCanceled: "zuora_all_plan_canceled",
//
//  /**課金処理一時的エラー(billings) */
//  SubscriptionRegistrationTempError: "subscription_registration_temp_error",
//
//  /**有料機能解放失敗エラー(billings) */
//  FailedToReleaseSubscription: "failed_to_release_subscription",
//
//  /**クレジットカード登録情報エラー(billings) */
//  CardInputInfoError: "card_input_info_error",
//
//  /**決済処理エラー(billings) */
//  PaymentProcessingError: "payment_processing_error",
//
//  /**メンバー招待時エラー(sk-server) */
//  SkserverCompanyInvitationOverfullError: "skserver_company_invitation_overfull_error",
//  SkserverInvitationMailAddressDuplicated: "skserver_invitation_mail_address_duplicated",
//
//  /**メンバー登録時エラー */
//  SkserverCompanyMembersOverfullError: "skserver_company_members_overfull_error",
//  SkserverRequiredBillingForInvitationMembersError:
//    "skserver_required_billing_for_invitation_members_error",
//
//  /**招待トークン有効判定エラー */
//  SkserverInvalidInvitationTokenNotExist: "skserver_invalid_invitation_token_not_exist",
//  SkserverInvalidInvitationTokenLimitOver: "skserver_invalid_invitation_token_limit_over",
//  SkserverInvalidInvitationTokenMembersOverfull:
//    "skserver_invalid_invitation_token_members_overfull",
//  SkserverInvalidInvitationTokenFree: "skserver_invalid_invitation_token_free",
//  IvServerInvitationInvalid: "iv_server_invitation_invalid",
//
//  /**プラン重複購入エラー(billings) */
//  ZuoraPlanDuplicate: "zuora_plan_duplicate",
//
//  /**解約対象が見つからないエラー(billings) */
//  ZuoraCancelPlanNotFound: "zuora_cancel_plan_not_found",
//
//  /**Zuoraプラン別グレード変更エラー グレードの違うプランに変更した場合(billings) */
//  ZuoraChangingDifferentGradeNotAllowed: "zuora_changing_different_grade_not_allowed",
//
//  /**エクスポート対象のデータが1件も存在しないエラー(発行請求書・取引先・品目) */
//  DataExportIssuanceInvoiceNotFound: "evidencer_data_export_issuance_invoice_not_found_warn",
//  DataExportPartnersNotFound: "evidencer_data_export_partners_not_found_warn",
//  DataExportItemsNotFound: "evidencer_data_export_items_not_found_warn",
//
//  /**エクスポート対象のデータ上限エラー(発行請求書・取引先・品目) */
//  DataExportIssuanceInvoiceOverLimit: "evidencer_data_export_partners_over_limit",
//  DataExportItemLimit: "evidencer_data_export_issuance_invoice_over_limit",
//  DataExportPartnerOverLimit: "evidencer_data_export_items_over_limit",
//
//  /**インポートデータのファイルが0行の時のエラー(発行請求書・取引先・品目) */
//  EvidencerDataImportIssuanceInvoiceNoRowsWarn:
//    "evidencer_data_import_issuance_invoice_no_rows_warn",
//  EvidencerDataImportPartnersNoRowsWarn: "evidencer_data_import_partners_no_rows_warn",
//  EvidencerDataExportItemsNoRowsWarn: "evidencer_data_export_items_no_rows_warn",
//
//  /**インポートデータのファイルが空の時のエラー */
//  EvidencerDataImportFileIsEmptyError: "evidencer_data_import_file_is_empty_error",
//
//  /**インポートデータのファイルサイズが規定以上のエラー */
//  EvidencerDataImportFileSizeIsOverError: "evidencer_data_import_file_size_is_over_error",
//
//  /**インポートデータの行数が規定以上のエラー */
//  EvidencerDataImportFileHasOverLinesError: "evidencer_data_import_file_has_over_lines_error",
//
//  /**インポートデータのヘッダーが記入用テンプレートと一致しないエラー */
//  EvidencerDataImportFileHeaderRayoutIsUnmatchedError:
//    "evidencer_data_import_file_header_rayout_is_unmatched_error",
//
//  /**インポートデータに空行があるエラー */
//  EvidencerDataImportFileHasBlankLinesError: "evidencer_data_import_file_has_blank_lines_error",
//
//  /**インポートデータの項目数が不正のエラー */
//  EvidencerDataImportFileValueRayoutIsUnmatchedError:
//    "evidencer_data_import_file_value_rayout_is_unmatched_error",
//
//  /**インポートで指定した文字コードが不正のエラー */
//  EvidencerDataImportDecodeWarn: "evidencer_data_import_decode_warn",

  /**ログインエラー */
  ACCOUNTS_USER_PARAMETER_ERROR: "accounts_user_parameter_error",

//  /**ワークスペース承認リンク認証エラー */
//  APPROVAL_LINKS_AUTHENTICATION_DUPLICATION_ERROR:
//    "approval_links_authentication_duplication_error",
//
//  /**アクティベーションコード入力ですでに有償プランに加入済み */
//  SKSERVER_ALREADY_PAID_NOT_USE_ACTIVATION_CODE_WARN:
//    "skserver_already_paid_not_use_activation_code_warn",
//  /**アクティベーションコードが存在しない */
//  SKSERVER_ACTIVATION_CODE_NOT_EXIST_WARN: "skserver_activation_code_not_exist_warn",
//  /**アクティベーションコードがすでに使用済み */
//  SKSERVER_ALREADY_USED_ACTIVATION_CODE_WARN: "skserver_already_used_activation_code_warn",
//  /**退会時に有効なアクティベーションコードを利用 */
//  SKSERVER_USED_ACTIVATION_CODE_IN_WITHDRAWAL_CHECK_WARN:
//    "skserver_used_activation_code_in_withdrawal_check_warn",
//
//  /**発行請求書作成・訂正＞振込先口座情報の合計文字数オーバー */
//  EVIDENCER_PAYABLE_FINANCE_INFO_CHARACTERS_OVER_WARN:
//    "evidencer_payable_finance_info_characters_over_warn",
//  /**振込先登録＞振込先口座情報の合計文字数オーバー */
//  EVIDENCER_COMPANIES_PAYABLE_FINANCE_INFO_CHARACTERS_OVER_WARN:
//    "evidencer_companies_payable_finance_info_characters_over_warn",
//
  /**サムネイル・画像表示不可エラー */
  CAN_NOT_DISPLAY_THUMBNAIL_IMAGE_ERROR: "can_not_display_thumbnail_image_error",
  /**PdfFontCheckerのエラー */
  EVIDENCER_PDF_CHECKER_ERROR: "evidencer_pdf_checker_error",

//  /** GMOメンテナンスエラー */
//  GMO_MAINTENANCE_ERROR: "gmo_maintenance_error",
//
//  /** 外部API実行「国税庁のAPI」メンテナンス中 **/
//  EXTERNAL_NTA_MAINTENANCE: "evidencer_nta_maintenance_warn",
  
} as const;

export type ErrorTypeType = (typeof ErrorType)[keyof typeof ErrorType];

/**
 * サーバー警告コードのリスト
 */
const WarningCodeList = Object.values(ErrorType);

/**
 * NOTE: 以下のboolean変数を作成するのは、基本のエラーダイアログでなく別のダイアログ部品をエラーダイアログとして使用したい場合のみ
 * (基本のエラーダイアログで良い場合は、上記エラーコードに登録するだけで表示できる)
 */

/**
 * サーバーエラー理由が警告レベルに該当するか否か
 * @param reason サーバーエラー理由
 * @return true: 警告レベル, false:非警告レベル
 */
export const isWarning = (reason: string): boolean =>
  WarningCodeList.some((code) => code === reason);

/**
 * サーバーエラー理由が「404 Not Found」ステータスコードに該当するか否か
 * @param reason サーバーエラー理由
 * @return true: 404に該当, false:404に非該当
 */
// TODO: レスポンスのHTTPステータスコードで判定できるようになり次第、当関数は不要のため削除する
//export const is404NotFound = (reason: string): boolean =>
//  reason === ErrorCode.INVOICE_NOT_FOUND ||
//  reason === ErrorCode.RECEIPT_NOT_FOUND ||
//  reason === ErrorCode.DELIVERY_NOT_FOUND ||
//  reason === ErrorCode.QUOTATION_NOT_FOUND ||
//  reason === ErrorCode.PARTNER_NOT_FOUND;

/**
 * サーバーエラー理由が「セッションにsori_idが存在しないエラー」に該当するか否か
 * @param reason サーバーエラー理由
 * @return true: sori_idなしエラー該当, false: sori_idなしエラーに非該当
 */
//export const isSoriIDNotExist = (reason: string): boolean =>
//  reason === ErrorCode.IV_SERVER_SORI_ID_NOT_EXIST;

/**
 * サーバーエラー理由がアクセストークンの問題によるものか否か
 * @param reason サーバーエラー理由
 * @return true:該当, false:非該当
 */
//export const isInvalidAccessTokenError = (reason: string): boolean =>
//  reason === ErrorCode.ACCOUNTS_INVALID_ACCESS_TOKEN ||
//  reason === ErrorCode.ACCOUNTS_EXPIRED_ACCESS_TOKEN ||
//  reason === ErrorCode.LINKSTORAGE_INVALID_ACCESS_TOKEN ||
//  reason === ErrorCode.ANALYZER_INVALID_ACCESS_TOKEN ||
//  reason === ErrorCode.SP_INVALID_ACCESS_TOKEN;

/**
 * サーバーエラー理由が「CountValidationError」(課金前の利用可能書類数上限)ステータスコードに該当するか否か
 * @param reason サーバーエラー理由
 * @return true:該当, false:非該当
 */
//export const isBillingCountValidationError = (reason: string): boolean =>
//  reason === ErrorCode.EVIDENCER_INVOICE_ISSUANCE_COUNT_VALIDATION_ERROR ||
//  reason === ErrorCode.EVIDENCER_PAYMENT_NOTIFICATION_ISSUANCE_COUNT_VALIDATION_OVER_ERROR ||
//  reason === ErrorCode.EVIDENCER_INVOICE_RECEIVING_COUNT_VALIDATION_ERROR ||
//  reason === ErrorCode.EVIDENCER_OCR_EVIDENCE_COUNT_VALIDATION_ERROR ||
//  reason === ErrorCode.EVIDENCER_DATA_IMPORT_ISSUANCE_INVOICE_OVER_FREE_LIMIT ||
//  reason === ErrorCode.EVIDENCER_DATA_IMPORT_ISSUANCE_INVOICE_ALREADY_OVER_FREE_LIMIT;

/**
 * 退会時課金状態チェックエラーに該当するか否か
 * @param {string} reason - エラータイプ
 * @return {boolean} 課金済エラーに該当するか否か
 */
//export const isValidSubscriptionAlreadyExistError = (reason: string): boolean =>
//  reason === ErrorCode.ValidSubscriptionZuoraAlreadyExist ||
//  reason === ErrorCode.ValidNotAutoRenewSubscriptionZuoraAlreadyExist ||
//  reason === ErrorCode.SKSERVER_USED_ACTIVATION_CODE_IN_WITHDRAWAL_CHECK_WARN;

/**
 * 招待トークン有効判定エラーに該当するか否か
 * @param {string} reason - エラータイプ
 * @return {boolean} 招待トークン有効判定エラーに該当するか否か
 */
//export const isValidInvitationTokenExistError = (reason: string): boolean =>
//  reason === ErrorCode.SkserverInvalidInvitationTokenNotExist ||
//  reason === ErrorCode.SkserverInvalidInvitationTokenLimitOver ||
//  reason === ErrorCode.SkserverInvalidInvitationTokenMembersOverfull ||
//  reason === ErrorCode.SkserverInvalidInvitationTokenFree ||
//  reason === ErrorCode.IvServerInvitationInvalid;

/**
 * メール認証時のメンバー登録エラーに該当するか否か
 * @param {string} reason - エラータイプ
 * @return {boolean} メール認証時のメンバー登録エラーに該当するか否か
 */
//export const isRegisterMemberError = (reason: string): boolean =>
//  reason === ErrorCode.SkserverCompanyMembersOverfullError ||
//  reason === ErrorCode.SkserverRequiredBillingForInvitationMembersError;

/**
 * 権限ロールチェックエラー
 * @param {string} reason - エラータイプ
 * @return {boolean} 権限ロールチェックエラーかどうか
 */
//export const isRoleError = (reason: string): boolean =>
//  reason === ErrorCode.INVITATION_USER_IN_FREE_PLAN_ERROR;
